import React from 'react';
import * as S from './Avatar.styles';

type IAvatar = {
  photo: string;
  onClick?: () => void;
};

export const Avatar = ({ photo, onClick }: IAvatar) => {
  return (
    <S.AvatarStyled onClick={onClick}>
      <img src={photo} alt='Avatar' />
    </S.AvatarStyled>
  );
};
